import React from 'react'
import PropTypes from 'prop-types'
import { View } from 'components/View'
import ContentBox from 'components/ContentBox'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import TextBodySmaller from 'components/TextBodySmaller'
import ButtonPrimary from 'components/ButtonPrimary'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import { useTheme } from 'modules/styles'

const messages = defineMessages({
  checkYourForm: {
    id: 'UploadAnotherVideoSection.checkYourForm',
    defaultMessage: 'Check Your Form'
  },
  uploadAnotherVideo: {
    id: 'UploadAnotherVideoSection.uploadAnotherVideo',
    defaultMessage: 'Upload Another Video'
  },
  maxDuration: {
    id: 'UploadAnotherVideoSection.maxDuration',
    defaultMessage: 'Maximum duration: 20 seconds'
  }
})

export const UploadAnotherVideoSection = ({
  videoInputRef,
  isUploadingVideo,
  isAnalyzingForm,
  onUploadClick,
  onFileChange
}) => {
  const intl = useIntl()
  const theme = useTheme()

  return (
    <ContentBox
      mb={4}
      style={{
        border: `2px dashed ${theme.colors.border}`,
        backgroundColor: theme.colors.backgroundContent
      }}
      ac
    >
      <View mb={2}>
        <TextTitleCompressedHeavy>
          {formatMessageIntlUtil(intl, messages.checkYourForm)}
        </TextTitleCompressedHeavy>
      </View>

      <View mb={3}>
        <TextBodySmaller
          style={{ color: theme.colors.paragraph }}
        >
          {formatMessageIntlUtil(intl, messages.maxDuration)}
        </TextBodySmaller>
      </View>

      <input
        ref={videoInputRef}
        type='file'
        accept='video/mp4,.mp4'
        onChange={onFileChange}
        style={{ display: 'none' }}
      />

      <View
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <ButtonPrimary
          onClick={onUploadClick}
          isDisabled={isUploadingVideo || isAnalyzingForm}
          style={{
            width: '100%'
          }}
        >
          {formatMessageIntlUtil(intl, messages.uploadAnotherVideo)}
        </ButtonPrimary>
      </View>
    </ContentBox>
  )
}

UploadAnotherVideoSection.propTypes = {
  videoInputRef: PropTypes.object.isRequired,
  isUploadingVideo: PropTypes.bool.isRequired,
  isAnalyzingForm: PropTypes.bool.isRequired,
  onUploadClick: PropTypes.func.isRequired,
  onFileChange: PropTypes.func.isRequired
}
